// extracted by mini-css-extract-plugin
module.exports = {"amount-with-hint":"styles_amount-with-hint__zTykM"};